var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithubOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7399 0.5C9.72301 0.5 6.82972 1.7116 4.69648 3.86827C2.56324 6.02494 1.3648 8.95001 1.3648 12C1.36007 14.6479 2.23496 17.2208 3.84918 19.3061C5.46341 21.3914 7.72347 22.8683 10.267 23.5V20.5H9.27789C6.68635 20.5 5.77635 16.5 4.33221 16.5C7.0919 16.5 7.62603 18.5 9.27789 18.5C9.41201 18.5181 9.54846 18.5047 9.67663 18.4609C9.8048 18.417 9.92125 18.3439 10.0169 18.2472C10.1126 18.1504 10.185 18.0327 10.2283 17.9031C10.2717 17.7735 10.2849 17.6356 10.267 17.5V17.15C7.38864 16.33 5.32134 14.15 5.32134 11.5C5.34449 10.1214 5.90216 8.80707 6.87429 7.84C6.6265 7.29937 6.53495 6.69892 6.6102 6.10795C6.68546 5.51697 6.92446 4.95955 7.29962 4.5C8.20449 4.77464 9.01831 5.29319 9.65376 6C11.6475 5.26799 13.8323 5.26799 15.826 6C16.4614 5.29319 17.2753 4.77464 18.1801 4.5C18.5553 4.95955 18.7943 5.51697 18.8695 6.10795C18.9448 6.69892 18.8532 7.29937 18.6055 7.84C19.5776 8.80707 20.1352 10.1214 20.1584 11.5C20.1584 14.24 17.8933 16.5 14.7973 17.26C15.1162 17.9607 15.2589 18.7301 15.2127 19.5V23.5C17.7563 22.8683 20.0163 21.3914 21.6306 19.3061C23.2448 17.2208 24.1197 14.6479 24.1149 12C24.1149 8.95001 22.9165 6.02494 20.7833 3.86827C18.65 1.7116 15.7567 0.5 12.7399 0.5V0.5Z",
    stroke: "#303C42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.7393,
    height: 24,
    fill: "white",
    transform: "translate(0.870239)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubOutline);
export default __webpack_public_path__ + "static/media/GithubOutline.0e157e6faad741e90d09e3385e0ae88e.svg";
export { ForwardRef as ReactComponent };